module.exports = __webpack_public_path__ + "img/allGamesp.d3a6bcc0.svg";